import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const FILES_BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("lx_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  const o = localStorage.getItem("lx_org");
  if (o) c.headers["X-Org-Id"] = o;
  return c;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !e.config.url.includes("/auth/")) {
      localStorage.removeItem("lx_token");
      window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export function inr(n) {
  n = Number(n || 0);
  if (Math.abs(n) >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (Math.abs(n) >= 1e5) return `₹${(n / 1e5).toFixed(1)} L`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}

export const num = (n) => Number(n || 0).toLocaleString("en-IN");
export const dt = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "-");
export const refLabel = (r) => r?.name || r?.company_name || r?.customer_name || r?.title || r?.unit_number || r?.email || "-";
